import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import SideMenu from '../sideMenu/SideMenu';
import './Header.scss';
import SelectOffice from "./selectOffice/SelectOffice";
import {UserContext} from "../../state/UserContext";

const Header = ({isAdmin}) => {
    const [isHovered, setIsHovered] = useState(false);
    const toggle = () => {
        setIsHovered(!isHovered);
    };

    const {loggedUser} = useContext(UserContext);
    return (
        <div className="header">
            <Link to="/">
                <div className="logo-container">
                    <img src="./assets/images/grape_logo.svg" alt="headerLogo"/>
                    <img src="./assets/images/grejpapu.svg" alt="logo_grejpapu" className="header-logo"/>
                </div>
            </Link>
            <div className="header__actions">
                <SelectOffice/>
                <div
                    onMouseEnter={toggle}
                    onClick={toggle}
                    role="button"
                    tabIndex={0}
                    className="button-menu"
                >
                    <img src="./assets/images/hamburger_icon.svg" alt="hamburgerMenu"/>
                </div>
            </div>
            <SideMenu isAdmin={isAdmin} show={isHovered} onClose={toggle} {...loggedUser} />
        </div>
    );
}

export default Header;
